import { render, staticRenderFns } from "./champion-picker.vue?vue&type=template&id=1d714ddf&scoped=true&"
import script from "./champion-picker.ts?vue&type=script&lang=ts&"
export * from "./champion-picker.ts?vue&type=script&lang=ts&"
import style0 from "./champion-picker.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./champion-picker.vue?vue&type=style&index=1&id=1d714ddf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d714ddf",
  null
  
)

export default component.exports